import { render, staticRenderFns } from "./preferential-table.vue?vue&type=template&id=09470472&scoped=true"
import script from "./preferential-table.vue?vue&type=script&lang=js"
export * from "./preferential-table.vue?vue&type=script&lang=js"
import style0 from "./preferential-table.vue?vue&type=style&index=0&id=09470472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09470472",
  null
  
)

export default component.exports